import React, { useState } from "react";
import "../Styles/CommonButtonStyles.css";

const CommonButtonView = (props) => {
  const {name, Todo} = props
  const [isHovered, setIsHovered] = useState(false);
  const [shouldAnimate, setShouldAnimate] = useState(false);

  return (
    <button
      className="vertical-stripe-button"
      onMouseEnter={() => {
        setIsHovered(true);
        setShouldAnimate(true);
      }}
      onMouseLeave={() => setIsHovered(false)}
      onClick={Todo}
    >
      <span className={isHovered?"btn-text-hover":"btn-text"}>{name}</span>
      <div className="vertical-stripes">
        {Array.from({ length: 7 }).map((_, i) => {
          const delayIndex = isHovered ? i : 6 - i; 
          return (
            <div
              key={i}
              className={`v-stripe ${shouldAnimate ? (isHovered ? "slide-up-3" : "slide-down-3") : ""}`}
              style={{ "--i": delayIndex }}
            ></div>
          );
        })}
      </div>
    </button>
  );
};

export default CommonButtonView;